// Generated file : do not modify
import { ObjTypes } from '@/generated/classes/ObjTypes';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Propriétaire d'un objet'
export default class Owner  {
  // Type d'objet
  public objType: ObjTypes;
  // ID de l'objet
  public objId: number;

  constructor() {
    this.objType = ObjTypes.NONE;
    this.objId = 0;
  }

  public static fromJson (obj: Owner): Owner {
    const newOwner: Owner = new Owner();
    newOwner.objType = obj.objType;
    newOwner.objId = obj.objId;
    return newOwner;
  }

  public toJsonOwner (): string {
    const json = {
      objType: this.objType,
      objId: this.objId,
    }
    return JSON.stringify(json);
  }

  public fromOwner (obj: Owner): void {
    this.objType = obj.objType;
    this.objId = obj.objId;
  }

  public compareOwner (value: Owner): boolean {
    return (this.toJsonOwner() == value.toJsonOwner());
  }

  public cloneOwner (): Owner {
    return Owner.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(owners: Owner[]) {
  }
}
